<template>
    <b-nav-item-dropdown text="Tickets Mantenimiento"  v-show="isOK == true" left>   
        <b-dropdown-group id="dropdown-group-1" >
            <b-dropdown-item exact to="/home/ticketDashboard">Dashboard <span class="badge badge-info">{{abiertos}}</span> </b-dropdown-item>
              
    
        </b-dropdown-group>
            
           
    </b-nav-item-dropdown>
</template>

<script>
    import {mapState,mapActions} from 'vuex'
    import customMixin from '@/mixins/customMixin'
    export default {
        mixins : [customMixin],
        data: function(){
            return {
                isOK: false
            }
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('login',['rol_id']),
            ...mapState('permiso',['permiso']), 
            ...mapState('ticket',['abiertos']),
       
        },
        methods:{
            ...mapActions({
               _fetchPermisos: 'permiso/fetchPermisosUsuarios',
               _abiertos:'ticket/fetchTicketTotalAbierto',
            }),
            init(){
                this._fetchPermisos(this.rol_id).then(() => {  
                    this.isOK =  this.isTicketsMantenimiento(this.permiso) 
                })
                this._abiertos()
            },
        }//end methods         
    }
</script>

<style lang="scss" scoped>

</style>